import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full bg-gold" data-id="element-13" data-mp="2tgqpao3xs0lk">
      <p className="mx-auto max-w-editorial px-5 py-2.5 text-center font-display text-[10px] font-semibold uppercase tracking-[0.18em] text-white md:text-[11px] md:tracking-luxe" data-id="element-14" data-mp="ol26o89o118q">
        Get 10% off on your first order | Free shipping in NY
      </p>
    </div>;
}